import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsBikeNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M2 3h4v1.25h-.566l.429.75h3.972l-.422-1.161A.625.625 0 0110 3h3.5a1.5 1.5 0 010 3H13V4.75h.5a.25.25 0 100-.5h-2.608l1.018 2.8a3.5 3.5 0 11-1.175.427l-.324-.894-2.423 4.11A.625.625 0 017.45 11h-.485a3.5 3.5 0 11-2.39-3.832l.516-.999L3.994 4.25H2zm3.83 4.463L4.65 9.75h2.443l.022-.038zm2.017 1.009l1.31-2.222h-2.58zM3.5 8.25A2.25 2.25 0 105.694 11H3.625a.625.625 0 01-.555-.912l.92-1.784a2.258 2.258 0 00-.49-.054zm7.674.432a2.25 2.25 0 101.175-.427l.952 2.619-1.175.427z"
        fill=""
      />
    </svg>
  )
);
SvgSportsBikeNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsBikeNormalXsmall;
